let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8kjXz")).then(() => parcelRequire('ieUfL'));